import React, { Component } from 'react';
import _ from 'lodash';
import axios from 'axios';
import { Label, Divider, Card } from 'semantic-ui-react';

import ReportHeader from '../../components/report-header';
import ReportHeroContent from '../../components/report-hero-content';
import ReportSupportingActivity from '../../components/report-supporting-activity';
import ReportNetworkActivity from '../../components/report-network-activity';
import ReportSummary from '../../components/report-summary';
import UserDetailsModal from '../../components/user-details-modal';
import InfluencerCardGroup from '../../components/influencer-card-group';
import PlainReport from 'dyzio-shared-components/lib/reports/plain-report';

const snickersData = require('./data/callux-snickers-2017').reportData;
const bladerunnerData = require('./data/callux-bladerunner-2017').reportData;
const neutrogenaData = require('./data/aspyn-neutrogena-2017').reportData;
const jumanjiData = require('./data/callux-jumanji-2017').reportData;
const dragonCityData = require('./data/callux-dragon-city-2017').reportData;
const formulaData = require('./data/callux-FIAFormulaE-2018').reportData;
const afgVisitBritainData = require('./data/afg-visit-britain-2017').reportData;


const voxiData = require('./data/voxi-endless-challenge-2018').reportData;
const voxiDataCallux = require('./data/voxi-endless-challenge-2018').reportData;
const voxiDataOli = require('./data/voxi-endless-challenge-2018-oli').reportData;
const voxiDataCaspar = require('./data/voxi-endless-challenge-2018-caspar').reportData;

const REPORT_TIMEOUT = 50000;

const CALLUX = {
  name: 'Callux',
  color: 'pink',
  hashtag: '#TeamCallux',
  discussionName: 'Callux',
};

const CASPAR = {
  name: 'Caspar Lee',
  color: 'green',
  hashtag: '#TeamCaspar',
  discussionName: 'dicasp',
};

const OLI = {
  name: 'Oli White',
  color: 'yellow',
  hashtag: '#TeamOli',
  discussionName: 'TheOliWhiteTV',
};


const VOXI_DATA = {
  [CALLUX.name]: voxiDataCallux,
  [CASPAR.name]: voxiDataCaspar,
  [OLI.name]: voxiDataOli,
};

const IS_PRODUCTION = process.env.NODE_ENV === 'production';

const reports = {
  'callux-jumanji-2017': jumanjiData,
  'callux-snickers-2017': snickersData,
  'callux-bladerunner-2017': bladerunnerData,
  'aspyn-neutrogena-2017': neutrogenaData,
  'callux-dragon-city-2017': dragonCityData,
  'callux-fiaformulae-2018': formulaData,
  'afg-visit-britain-2017': afgVisitBritainData,
  'voxi-endless-challenge-2018': voxiData,
};

const PROFILE_KEY = 'DYZIO_PROFILE';

class CampaignReport extends Component {
  constructor() {
    super();
    this.state = { profile: null, selectedInfluencer: null };
    // TODO Generate token, refactor this code

    // TODO Generate token, refactor this code
    this.reportClient = axios.create({
      baseURL: process.env.REACT_APP_REPORT_API_URL,
      timeout: REPORT_TIMEOUT,
      headers: {
        Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhcHBfbWV0YWRhdGEiOnsicm9sZXMiOlsidXNlciJdLCJkeXppbyI6eyJ1X2lkIjoiZGVhNDVhMmMtYWQ0MS00OGQ2LWIxYjQtOGFlZjQ1NjZjNGZiIiwibmFtZSI6IkRhbiBDYW50aXIiLCJlbWFpbCI6ImRhbi5jYW50aXJAYXRvbWF0ZS5uZXQiLCJvX2lkIjoiZjE0ZDM5MzEtMGU2YS00MmU4LWFkM2MtYWUyZmYwN2UzZDk2Iiwicm9sZSI6IlRFQU1fTUVNQkVSIiwidmVyc2lvbiI6MX19LCJpc3MiOiJodHRwczovL2R5emlvLmV1LmF1dGgwLmNvbS8iLCJzdWIiOiJhdXRoMHw1OGI1NmMxYmIzM2M1NTQ2Nzg3YWE0NTYiLCJhdWQiOiJNeHVFWmthWHF1Wm5sSmVMOW9FOFFoeVF6aE10amZUcCIsImlhdCI6MTUwOTcwNzU2NCwiZXhwIjoxNTA5NzQzNTY0fQ.sIKlNtois5uMAKWrGD4tsfiNtT7JsqSnamFVRmRFXmg',
      },
    });

    this.client = axios.create({
      baseURL: process.env.REACT_APP_NOTIFY_API_URL,
      timeout: 2000,
      headers: {
        Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhcHBfbWV0YWRhdGEiOnsicm9sZXMiOlsidXNlciJdLCJkeXppbyI6eyJ1X2lkIjoiZGVhNDVhMmMtYWQ0MS00OGQ2LWIxYjQtOGFlZjQ1NjZjNGZiIiwibmFtZSI6IkRhbiBDYW50aXIiLCJlbWFpbCI6ImRhbi5jYW50aXJAYXRvbWF0ZS5uZXQiLCJvX2lkIjoiZjE0ZDM5MzEtMGU2YS00MmU4LWFkM2MtYWUyZmYwN2UzZDk2Iiwicm9sZSI6IlRFQU1fTUVNQkVSIiwidmVyc2lvbiI6MX19LCJpc3MiOiJodHRwczovL2R5emlvLmV1LmF1dGgwLmNvbS8iLCJzdWIiOiJhdXRoMHw1OGI1NmMxYmIzM2M1NTQ2Nzg3YWE0NTYiLCJhdWQiOiJNeHVFWmthWHF1Wm5sSmVMOW9FOFFoeVF6aE10amZUcCIsImlhdCI6MTUwOTcwNzU2NCwiZXhwIjoxNTA5NzQzNTY0fQ.sIKlNtois5uMAKWrGD4tsfiNtT7JsqSnamFVRmRFXmg',
      },
    });
  }

  getProfile = () => {
    // Retrieves the profile data from localStorage
    const profile = localStorage.getItem(PROFILE_KEY);
    return profile ? JSON.parse(profile) : null;
  }

  componentDidMount = () => {
    const profile = this.getProfile();
    console.log(`[PROFILE_KEY]: ${profile}`);

    const { name } = this.props.match.params;
    const data = reports[_.toLower(name)];

    this.fetchReport();

    this.setState({
      profile,
      data,
    }, this.notify);
  }

  setProfile = profile => {
    console.log(`[setProfile]: ${profile}`);

    localStorage.setItem(PROFILE_KEY, JSON.stringify(profile));
    this.setState({
      profile,
    }, this.notify);
  }

  fetchReport = () => {
    const id = '617253d1-6671-4760-b1c9-ce77dbd050ed';
    const type = 'basic';

    this.reportClient.post('/', {
      id, type,
    }).then(response => {
      const { data } = response;
      const posts = _.filter(data.data.posts, (
        post => !_.isNull(post)
        && !_.isUndefined(post.trackedAsset)
        && (post.trackedAsset.platform !== 'YOUTUBE')
      ));
      data.data.posts = posts;

      const campaign = {
        name: data.data.name,
      };

      this.setState({
        liveData: data,
        id,
        type,
        loading: false,
        campaign,
      }, this.notify);
    }).catch(error => {
      this.setState({
        loading: false, error, campaign: { name: 'error loading campaign' },
      }, this.notify);
    });
  }

  notify = () => {
    const { profile, data } = this.state;
    const { href } = window.location;

    if (profile) {
      const campaign = {
        name: data.info.campaignName,
      };
      const notification = {
        data: {
          profile,
          campaign,
          href,
        },
      };
      console.log(notification);

      if (IS_PRODUCTION) {
        this.client.post('/', notification)
          .then(() => console.log('notified OK.'))
          .catch(e => console.log(e));
      }
    }
  }

  selectInfluencer = influencer => {
    console.log(influencer);

    const data = VOXI_DATA[influencer.name];
    this.setState({
      selectedInfluencer: influencer,
      data,
    });
  }

  render = () => {
    const { name } = this.props.match.params;
    const { profile, data, selectedInfluencer, liveData } = this.state;
    const isProfileSet = Boolean(profile);

    let influencerPosts;
    const postsDto = { data: {} };

    if (liveData && selectedInfluencer) {
      const { posts } = liveData.data;
      console.log(selectedInfluencer.discussionName);
      influencerPosts = _.filter(posts, (
        post => (post.trackedAsset.discussionName === selectedInfluencer.discussionName)
      ));
      postsDto.data.posts = influencerPosts;
    }

    const IS_VOXI = (name === 'voxi-endless-challenge-2018');
    const x = {
      sort: 'values.totals.followersCount',
      groupBy: 'influencer',
      order: {
        basic: {
          field: null,
          value: null,
        },
      },
      filter: {
        basic: {
          platform: null,
          handle: null,
        },
      },

    };

    if (data) {
      console.log('[CampaignReport]');
      console.log(name);

      const summaryData = {
        totalViews: _.reduce(data.supportingActivity, (sum, n) => (sum + (n.views || 0)), 0) + data.youtubeViews,
        totalEngagements: _.reduce(data.supportingActivity, (sum, n) => (sum + (n.engagements || 0)), 0) + data.youtubeEngagements,
      };

      return (
        <div>
          <ReportHeader info={data.info} />

          { IS_VOXI &&

            <div>
              <Divider />

              <h2 style={{ textAlign: 'center' }}>select an influencer to view their campaign report</h2>

              <Divider />

              <InfluencerCardGroup onClick={this.selectInfluencer} selectedInfluencer={selectedInfluencer} />

              <Divider />

              <h1 style={{ textAlign: 'center' }}>
                { selectedInfluencer && <Label basic size="massive" color={selectedInfluencer.color}>{_.toUpper(selectedInfluencer.name)}</Label> }
              </h1>

              {
                selectedInfluencer &&

                <div>
                  <Divider />

                  <ReportHeroContent mainData={data.heroData.main} />

                  <Card fluid>
                    <Card.Content>
                      <Card.Header>
                        Supporting activity
                      </Card.Header>
                      <Card.Meta>
                        { selectedInfluencer.name }&apos;s supporting posts on other social networks
                      </Card.Meta>
                    </Card.Content>
                    <PlainReport data={postsDto} filter={x.filter} sort={x.sort} order={x.order} />
                  </Card>

                  <br />
                  <br />

                </div>
              }

            </div>

          }

          {
            !IS_VOXI &&

            <div>
              <UserDetailsModal open={!isProfileSet} successHandler={this.setProfile} />
              <ReportHeroContent mainData={data.heroData.main} />
              <ReportSupportingActivity posts={data.supportingActivity} supportingData={data.heroData.supportingData} info={data.info} />
              { data.networkActivity && <ReportNetworkActivity posts={data.networkActivity} /> }
              <ReportSummary data={summaryData} />
            </div>
          }


        </div>
      );
    }

    return (
      <div>could not find your report</div>
    );
  };
}
export default CampaignReport;



// WEBPACK FOOTER //
// ./src/containers/campaign-report/index.js